import React, { useEffect, useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import { Menu } from '../@types/strapiDocs';
import useLoadData from '../hooks/useLoadData';

interface Props {
  position?: string;
  theme?: string;
}

const HeaderComponent: React.FC<Props> = ({ position, theme }) => {
  const [hasBrandLogo, setHasBrandLogo] = useState<boolean>(false);
  const [clientLogo, setClientLogo] = useState<string | null>(null);

  const { data } = useLoadData<Menu>('/menu', {
    populate: {
      Logo: true,
      LogoColor: true,
      MenuItem: {
        populate: {
          SubItem: true,
        },
      },
    },
  });

  useEffect(() => {
    try {
      const storedClientLogo = localStorage.getItem('clientLogo');
      if (storedClientLogo && storedClientLogo.trim() !== '') {
        setHasBrandLogo(true);
        setClientLogo(storedClientLogo);
      } else {
        setHasBrandLogo(false);
        setClientLogo(null);
      }
    } catch (error) {
      console.error('Error al cargar el logo del cliente:', error);
      setHasBrandLogo(false);
      setClientLogo(null);
    }
  }, []);

  // Menu options
  const menuName = data?.attributes?.Name || '';
  const menuLogo = data?.attributes?.Logo?.data?.attributes?.url || '';
  const menuLogoColor =
    data?.attributes?.LogoColor?.data?.attributes?.url || '';

  const brandContent = (
    <>
      {(menuLogoColor || menuLogo) && (
        <img
          src={theme === 'light' ? menuLogoColor : menuLogo}
          alt={menuName}
        />
      )}
      {menuName && (
        <span
          className={`${
            theme === 'light' ? 'text-blue700' : 'text-white'
          } text-uppercase text-16`}
        >
          {menuName}
        </span>
      )}
    </>
  );

  return (
    <header
      className={`${position === 'relative' ? 'header--relative' : ''} ${
        theme === 'light' ? 'header--light' : ''
      }`}
    >
      <Navbar expand="lg" className="header__inner">
        <Container>
          {hasBrandLogo && clientLogo ? (
            <div className="header__logo-container">
              <img src={clientLogo} alt={menuName} className="extra-logo" />
              <Navbar.Brand href="/">{brandContent}</Navbar.Brand>
            </div>
          ) : (
            <Navbar.Brand href="/">{brandContent}</Navbar.Brand>
          )}

          {/* Menú de navegación oculto */}
          {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {menuItems.map((menuItem: MenuItem) =>
                menuItem.SubItem && menuItem.SubItem.length > 0 ? (
                  <NavDropdown key={menuItem.id} title={menuItem.Name}>
                    {menuItem.SubItem.map((subItem: Link) => (
                      <NavDropdown.Item
                        key={subItem.id}
                        href={subItem.Url || '#'}
                      >
                        {subItem.Name}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                ) : (
                  <Nav.Link
                    key={menuItem.id}
                    href={menuItem.Url || '#'}
                    target={menuItem.ExternalLink ? '_blank' : '_self'}
                    rel="noreferrer"
                  >
                    {menuItem.Name}
                  </Nav.Link>
                )
              )}
              <Nav.Link href="/inicio-de-sesion" className="nav__profile">
                <i
                  className={`${
                    theme === 'light' ? 'icon--profile-color' : 'icon--profile'
                  } icon`}
                ></i>
                <span>Mi perfil</span>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse> */}
        </Container>
      </Navbar>
    </header>
  );
};

export default HeaderComponent;
